import { DotsHorizontalCircleOutlineIcon } from './DotsHorizontalCircleOutlineIcon';

/**
 * author: Michael Richins
 * id 378E8311-F963-41EC-9AFF-5B30EF975313
 * name dots-horizontal-circle-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-horizontal-circle-outline.svg
 * tags
 */
export const MoreCircleOutlineIcon = DotsHorizontalCircleOutlineIcon;
export default MoreCircleOutlineIcon